const environment = {
  BACKEND_BASE_URL: "http://localhost:8080",
  MORALIS_APP_ID: "Cong0Rh8UwDPV5HC4U0nCPxiwEz5PAxeFLP2f3i0",
  MORALIS_SERVER_URL: "https://nbnob0befkpo.usemoralis.com:2053/server",
  NFT_CONTRACT: {
    11155111: "0x799e8F5419bB914cDb600c419C0B4F972C8578d9",
    56: "0x983e398513489a80EA5B9c7EDBdD83bF6dBE5659",
    "eip155:56": "0x983e398513489a80EA5B9c7EDBdD83bF6dBE5659",
  },
  PUBLIC_RPC: {
    11155111: "https://ethereum-sepolia.publicnode.com",
    56: "https://binance.llamarpc.com",
  },

  OWNER_STARK_KEY:
    "0x62120df211c64e8e1f84eb3c04fadd223c3ca7a76284e47694805c4b767b923",
  REQUEST_ID: "3daa9bc9-a2a0-48de-9cc7-623c04ca7c34",
  PROJECT_ID: "32",
  GROUP_REQUEST_ID: "7257d29c-c96a-4302-8eaf-368a0d62b977",
  NFT_CONTRACT: "0x0ff39AeDC8E6a37212F8Fc96bc5c107AB6D1990A",
  SENDER_ADDRESS: "0xa881eF338fCfE85cB64f68e2AeA0b8664131055c",
  MYRIA_PRIVATE_KEY:
    "59b2b64a1c915a6613fe3dbd26fb75d1ea0e519786717a9a1ab18810379ff64",
  NETWORK: "MAINNET",
  // new data

  ELG_NFT: {
    56: "0x952aE714c7Da56051FbC9fd87739868aBC3E4fC1",
    //56:"0xA91Dd7DAbC77d4BaCAfB7DD1DB3d853C03AbFf4b", v2
    // 56: "0x0960f7FB285fBb96AC6d7f2d07b4439deE3eeB49", //older
    11155111: "0xB17A18a8BCe692E47f8e423e375bE74ec73506e7",
  },
  ENERGY_TOKEN: {
    56: "0xCc9A5Ee831A418d68a43beF6b390d291a7594471",
    //56: "0xd7888E51051a4CEb3E509508f976bc292AF00363",
    11155111: "0x91f3C4a30142041D7B0e8888F773b2f60E9a891a",
  },
  STAKING_CONTRACT: {
    56: "0xb489b29549b077353e61204388d55aeba73dC2F4",
    //56:"0x673133349fa533B855f4Fe0598bD2BCF7A8191e0",
    //56: "0x4b2248184092ab72E7C3d04f94A137C858A0a55E",v2
    // 56: "0x66fD33e4F4Cd06c569eDd1Fb5567b63BfEB0190E", older
    11155111: "0x2EABaad5ABCccD75dAD304D29e4c468972893b0a",
  },
  TOKEN_CONTRACT: {
    11155111: "0x348dac9d03b4d2492e6657f04f9e261708f8ea5a",
    56: "0xD6eF2222Cc850fDc7Ee30F2B2D5384e0167700A3",
    "eip155:56": "0xD6eF2222Cc850fDc7Ee30F2B2D5384e0167700A3",
  },
  DEFAULT_CHAIN: 56,
  DEFAULT_HEX_CHAIN: "0x38",
  // DEFAULT_CHAIN: 11155111,
  // DEFAULT_HEX_CHAIN: "0xaa36a7",
  ENERGY_TOKEN_DECIMALS: 18,
  SPACE_ID: {
    56: "0xE3b1D32e43Ce8d658368e2CBFF95D57Ef39Be8a6",
    11155111: "0x24Bd0A8025f31250a249935Bb5E3090A59e16b7f",
  },
  GAS_PRICE_BUFFER: 1000,
  GAS_LIMIT_BUFFER: 100000,
};

export default environment;
